import { NGXAjax } from '../../common/Services/AjaxService';
import { ApiUtils } from '../../common/api';
import PageTemplateCollection from './page-template-collection';

function fetchPageTemplates(validFor, formatType) {
  return NGXAjax.get('api/pagetemplate/list.json', { validFor, formatType_filter: formatType, offset: 0, max: 50 })
    .then(ApiUtils.validate)
    .then(ApiUtils.extract)
    .then(PageTemplateCollection.deserialize)
    .catch(error => error);
}

export default {
  fetchPageTemplates,
};
